var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProcessorWorker } from '@shared/vendors/PFSVendor/WebFix/ProcessorWorker';
import { Connection } from '../Connection';
export var GoogleAuthMessageType;
(function (GoogleAuthMessageType) {
    GoogleAuthMessageType["SendGoogleAuthRequest"] = "SendGoogleAuthRequest";
    GoogleAuthMessageType["SendGoogleAuthConfirmRequest"] = "SendGoogleAuthConfirmRequest";
})(GoogleAuthMessageType || (GoogleAuthMessageType = {}));
export class GoogleAuthManager {
    constructor() { }
    SendGoogleAuthRequest(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendGoogleAuthMessage(GoogleAuthMessageType.SendGoogleAuthRequest, userID);
        });
    }
    SendGoogleAuthConfirmRequest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendGoogleAuthMessage(GoogleAuthMessageType.SendGoogleAuthConfirmRequest, data);
        });
    }
    sendGoogleAuthMessage(msgType, dataForMsg) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = { msgType, dataForMsg };
            const { ServerAdressesArray, isSSL } = Connection.vendor.loginParams;
            return this.SendMessagePromise(request, ServerAdressesArray, isSSL, 0).then((response) => response);
        });
    }
    SendMessagePromise(request, connectServers, isSSL, index) {
        if (index >= connectServers.length) {
            return Promise.resolve('Bad Arguments');
        }
        return Connection.SendMessageToVendor(connectServers[index], isSSL, request.msgType, request.dataForMsg, ProcessorWorker.MODE_AUTHENTICATION_REQUEST).then((response) => response !== null && response !== void 0 ? response : this.SendMessagePromise(request, connectServers, isSSL, index + 1));
    }
}
